import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaBusinessActivityExposures({ data, show, isModernProduct }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Name)}</th>
                    <th>{translator(messages.Type)}</th>
                    <th>{translator(messages.Description)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.BusinessActivityExposures)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((exposure) => {
                            const activityType = isModernProduct? exposure.businessClass: exposure.type;
                            return (
                                <>
                                    <tr>
                                        <td><strong>{exposure.name}</strong></td>
                                        <td><strong>{activityType}</strong></td>
                                        <td>{exposure.description}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaBusinessActivityExposures.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool,
    isModernProduct: PropTypes.bool
};
MLUmbrellaBusinessActivityExposures.defaultProps = {
    data: [],
    show: false,
    isModernProduct: false
};
export default MLUmbrellaBusinessActivityExposures;
